import { render, staticRenderFns } from "./chooseRoofTile.vue?vue&type=template&id=1039ac6d&scoped=true"
import script from "./chooseRoofTile.vue?vue&type=script&lang=js"
export * from "./chooseRoofTile.vue?vue&type=script&lang=js"
import style0 from "./chooseRoofTile.vue?vue&type=style&index=0&id=1039ac6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1039ac6d",
  null
  
)

export default component.exports